import { Suspense } from "react";
import { styled } from "@mui/material";
import { ErrorBoundary } from "react-error-boundary";

import { useUuidContext } from "hooks/routerHooks";

import { MainStyles } from "layout/MainStyles.";

import { AlertErrorBoundary } from "components/boundary/AlertErrorBoundary";
import { ResultPageLoader } from "components/loader/ResultPageLoader";
import { ResultPageSkeleton } from "components/skeletons/ResultPageSkeleton";

export function ResultPage() {
  const { uuid } = useUuidContext();
  return (
    <Styles>
      <ErrorBoundary
        FallbackComponent={(props) => <AlertErrorBoundary {...props} />}
      >
        <Suspense fallback={<ResultPageSkeleton />}>
          <ResultPageLoader uuid={uuid} />
        </Suspense>
      </ErrorBoundary>
    </Styles>
  );
}

const Styles = styled(MainStyles)`
  overflow: auto;
  flex-direction: column;
`;
